export default function InitHeaderScroll() {
    const header = document.querySelector('.header');

    if (!header) {
        return;
    }

    // expose real header height so full-bleed heroes can extend behind it
    const updateHeaderHeight = () => {
        document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    };

    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    updateHeaderHeight();

    // expose the logo's real left edge so other elements (e.g. the header
    // teaser's floating-card variant) can line their own left edge up with
    // it. The header's own left inset isn't a simple two-tier value like
    // ".content"'s padding — .header/.header-main__logo have their own
    // breakpoint-specific padding that changes at several widths — so this
    // measures the actual rendered position instead of duplicating that
    // scale as a second, easily-drifting set of breakpoints.
    const updateHeaderLogoInset = () => {
        const logo = header.querySelector('.header-main__logo');
        if (logo) {
            document.documentElement.style.setProperty('--header-logo-left', logo.getBoundingClientRect().left + 'px');
        }
    };

    window.addEventListener('resize', updateHeaderLogoInset, { passive: true });
    updateHeaderLogoInset();

    if (header.classList.contains('header--transparent')) {
        const updateHeader = () => {
            header.classList.toggle('header--scrolled', window.scrollY > 10);
        };

        window.addEventListener('scroll', updateHeader, { passive: true });
        updateHeader();
    }

    // hide the header on scroll-down, bring it back on scroll-up — standard
    // pattern, same on desktop and mobile. Never hide while the mobile menu
    // or a dropdown is open (both live inside .header, sliding it away would
    // take whatever's open with it), and only past the header's own height
    // so it doesn't twitch on the first few pixels of scroll.
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateScrollDirection = () => {
        const currentScrollY = Math.max(window.scrollY, 0);
        const scrolledDown = currentScrollY > lastScrollY;
        const pastHeaderHeight = currentScrollY > header.offsetHeight;
        const menuOrDropdownOpen = header.classList.contains('header--menu-open')
            || header.querySelector('.nav-item--first-level:hover, .nav-item--first-level.active');

        if (menuOrDropdownOpen) {
            header.classList.remove('header--hidden');
        } else if (scrolledDown && pastHeaderHeight) {
            header.classList.add('header--hidden');
        } else if (!scrolledDown) {
            header.classList.remove('header--hidden');
        }

        lastScrollY = currentScrollY;
        ticking = false;
    };

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(updateScrollDirection);
            ticking = true;
        }
    }, { passive: true });
}
